/**
 * Legacy PDP breadcrumb collection persistence has been replaced by pure product.type breadcrumbs.
 * Clean up any existing session storage key.
 */
(function () {
  try {
    sessionStorage.removeItem('cw_bc_collection');
  } catch (e) {}
})();
